export default __webpack_public_path__ + "static/media/bluecurve.792dc550.svg";